module.exports = __webpack_public_path__ + "img/calendar.5aadf340.png";